// src/utils/clipboard.js
// Safari (every iPhone, in any browser app) only allows a clipboard write while the tap
// is still "fresh". If the code awaits a download first, the permission is lost and the
// copy fails silently. So the write starts immediately and the image is handed to
// ClipboardItem as a promise that resolves later.

const loadImage = (blob) =>
  new Promise((resolve, reject) => {
    const url = URL.createObjectURL(blob);
    const img = new Image();
    img.onload = () => { URL.revokeObjectURL(url); resolve(img); };
    img.onerror = () => { URL.revokeObjectURL(url); reject(new Error("Image decode failed")); };
    img.src = url;
  });

// Clipboard only accepts image/png, so anything else is redrawn on a canvas.
const toPngBlob = async (src) => {
  const res = await fetch(src);
  const blob = await res.blob();
  if (blob.type === "image/png") return blob;
  const img = await loadImage(blob);
  const canvas = document.createElement("canvas");
  canvas.width = img.naturalWidth;
  canvas.height = img.naturalHeight;
  canvas.getContext("2d").drawImage(img, 0, 0);
  return new Promise((resolve, reject) =>
    canvas.toBlob(
      (png) => (png ? resolve(png) : reject(new Error("PNG conversion failed"))),
      "image/png"
    )
  );
};

// Call this FIRST in the click handler, with nothing awaited before it.
export const copyImageToClipboard = (src) =>
  navigator.clipboard.write([new ClipboardItem({ "image/png": toPngBlob(src) })]);